var _style, _g, _defs, _g2, _defs2, _g3, _defs3, _defs4, _g4, _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path3, _g5, _path4, _path5, _rect12, _rect13, _path6, _defs5, _g6, _defs6, _g7, _defs7, _defs8, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSigninIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 438.8 470.4",
    style: {
      enableBackground: "new 0 0 438.8 470.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECECE9;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#FBA919;}\n\t.st3{fill:#FEDA1E;}\n\t.st4{fill:#FFF0C6;}\n\t.st5{clip-path:url(#SVGID_4_);}\n\t.st6{clip-path:url(#SVGID_6_);}\n\t.st7{opacity:0.33;}\n\t.st8{clip-path:url(#SVGID_8_);}\n\t.st9{fill:#FFC60B;}\n\t.st10{opacity:0.67;}\n\t.st11{opacity:0.61;}\n\t.st12{clip-path:url(#SVGID_10_);}\n\t.st13{clip-path:url(#SVGID_12_);}\n\t.st14{clip-path:url(#SVGID_14_);}\n\t.st15{opacity:0.2;}\n\t.st16{clip-path:url(#SVGID_16_);}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Lag_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    className: "st0",
    d: "M438.6,342.4V130.6c-0.1-7.5-4.3-14.4-10.9-17.8L230.7,6.5C224,3,216,3,209.4,6.5l-197,106.2 c-6.7,3.5-10.9,10.3-11,17.8v211.8c0.1,7.5,4.3,14.4,10.9,17.8l197,106.2c6.7,3.6,14.7,3.6,21.3,0l197-106.2 C434.3,356.8,438.5,349.9,438.6,342.4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_361"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M209.3,6.5l-197,106.2c-6.7,3.5-10.9,10.3-11,17.8v211.8c0.1,7.5,4.3,14.4,10.9,17.8l197,106.2 c6.7,3.6,14.7,3.6,21.3,0l197-106.2c6.7-3.5,10.9-10.3,10.9-17.8V130.6c-0.1-7.5-4.3-14.4-10.9-17.8L230.6,6.5 C224,3,215.9,3,209.3,6.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1427",
    x: 228.6,
    y: 221.6,
    className: "st2",
    width: 12.8,
    height: 21.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1428",
    x: 214,
    y: 208.8,
    className: "st2",
    width: 42,
    height: 13.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1429",
    x: -27.1,
    y: 87.5,
    className: "st2",
    width: 182.5,
    height: 34.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    x: 143.9,
    y: -294.3,
    className: "st2",
    width: 34.4,
    height: 385.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    className: "st3",
    d: "M137.6,129.9h0.6c25.5-0.1,46.1-20.8,46.1-46.4h-46.7L137.6,129.9L137.6,129.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1431",
    x: -116.2,
    y: -294.3,
    className: "st4",
    width: 1157.3,
    height: 800.1
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_363"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M209.3,6.5l-197,106.2c-6.7,3.5-10.9,10.3-11,17.8v211.8c0.1,7.5,4.3,14.4,10.9,17.8l197,106.2 c6.7,3.6,14.7,3.6,21.3,0l197-106.2c6.7-3.5,10.9-10.3,10.9-17.8V130.6c-0.1-7.5-4.3-14.4-10.9-17.8L230.6,6.5 C223.9,3,215.9,3,209.3,6.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1432",
    x: 39.7,
    y: 23.5,
    className: "st2",
    width: 36.6,
    height: 201.4
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_368"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M209.3,6.5l-197,106.2c-6.7,3.5-10.9,10.3-11,17.8v211.8c0.1,7.5,4.3,14.4,10.9,17.8l197,106.2 c6.7,3.6,14.7,3.6,21.3,0l197-106.2c6.7-3.5,10.9-10.3,10.9-17.8V130.6c-0.1-7.5-4.3-14.4-10.9-17.8L230.6,6.5 C224,3,215.9,3,209.3,6.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 172.1,
    y: -16.1,
    width: 85.9,
    height: 534.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1433",
    x: 197.8,
    y: 3.9,
    className: "st2",
    width: 34.4,
    height: 511.7
  })))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    className: "st3",
    d: "M34.5,218.4c0,0.2,0,0.4,0,0.6c-0.1,25.5,20.5,46.3,46,46.4l0,0v-47H34.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1435",
    x: 294.9,
    y: -294.3,
    className: "st3",
    width: 34.4,
    height: 800.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    x: 220.2,
    y: 215.6,
    className: "st3",
    width: 29.3,
    height: 53
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1437",
    x: 371.4,
    y: 215.6,
    className: "st3",
    width: 29.3,
    height: 53
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1438",
    x: 328.8,
    y: 113.9,
    className: "st3",
    width: 29,
    height: 16.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    className: "st2",
    d: "M351.4,142.1c0-5.6,4.6-10,10.1-10c5.6,0,10,4.6,10,10.1s-4.5,10-10.1,10 C355.9,152.2,351.4,147.6,351.4,142.1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1439",
    x: 285.8,
    y: 102.7,
    className: "st9",
    width: 52.1,
    height: 38.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1440",
    x: -116.2,
    y: 346.4,
    className: "st9",
    width: 258.1,
    height: 34.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1441",
    x: 392.1,
    y: 421.5,
    className: "st3",
    width: 29.3,
    height: 53
  }))))))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    x: 79.6,
    y: 224.9,
    className: "st2",
    width: 141,
    height: 36.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1443",
    x: 249,
    y: 224.9,
    className: "st2",
    width: 122.3,
    height: 36.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1444",
    x: 399.6,
    y: 224.9,
    className: "st2",
    width: 39,
    height: 36.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1445",
    x: 160.8,
    y: 162.1,
    className: "st9",
    width: 277.9,
    height: 32.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    className: "st2",
    d: "M125.1,200.2c0-0.2,0-0.4,0-0.6c0-23.8,19-43.2,42.6-43.2v43.8H125.1z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1446",
    x: 1.3,
    y: 290.9,
    className: "st9",
    width: 437.3,
    height: 32.3
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    className: "st2",
    d: "M352.1,122.1c0-5.6,4.6-10,10.1-10c5.6,0,10,4.6,10,10.1s-4.5,10-10.1,10 C356.6,132.2,352.1,127.7,352.1,122.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    className: "st2",
    d: "M352.1,101.9c0-5.6,4.6-10,10.1-10c5.6,0,10,4.6,10,10.1s-4.5,10-10.1,10 C356.6,112,352.1,107.5,352.1,101.9L352.1,101.9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1447",
    x: 31.8,
    y: 136.8,
    className: "st3",
    width: 53,
    height: 29.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    x: 130.9,
    y: 200.2,
    className: "st9",
    width: 34.4,
    height: 154.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    className: "st2",
    d: "M171.1,340.1c0,0.2,0,0.4,0,0.6c0.1,25.5-20.5,46.3-46,46.4l0,0v-47H171.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 168.1,
    y: 382.1,
    width: 75.9,
    height: 80.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449",
    x: 188.1,
    y: 407.8,
    className: "st3",
    width: 53,
    height: 29.3
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 167.3,
    y: 81.8,
    width: 75.9,
    height: 80.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1451",
    x: 187.3,
    y: 107.5,
    className: "st3",
    width: 53,
    height: 29.3
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_381"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M208.7,2.7L11.9,109.6C5.3,113.1,1.1,120,1,127.5v213.2c0.1,7.6,4.3,14.5,10.9,18l196.8,106.9 c6.6,3.6,14.7,3.6,21.3,0l196.8-106.9c6.7-3.5,10.9-10.4,10.9-18V127.5c0-7.6-4.2-14.5-10.9-18L230,2.7 C223.4-0.9,215.3-0.9,208.7,2.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 2.6,
    y: 24.2,
    width: 466.8,
    height: 83.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1453",
    x: 5.5,
    y: 49.9,
    className: "st9",
    width: 444,
    height: 32.3
  }))))))))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    className: "st17",
    d: "M437.8,342.7V129.6c0-7.6-4.2-14.5-10.9-18L230.1,4.7c-6.6-3.6-14.7-3.6-21.3,0L11.9,111.6 C5.3,115.1,1.1,122,1,129.6v213.2c0.1,7.6,4.2,14.5,10.9,18l196.8,106.9c6.6,3.6,14.7,3.6,21.3,0l196.8-106.9 C433.5,357.2,437.7,350.3,437.8,342.7z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninIllustration);
export default __webpack_public_path__ + "static/media/signin-illustration.a816182d.svg";
export { ForwardRef as ReactComponent };